var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vTableSimple',{staticClass:"margin-15",attrs:{"columns":_vm.getColumns,"data":_vm.getData,"loading":_vm.loading,"border":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }